import Escalas from '@/views/admin/escalas'
import EscalaSave from '@/views/admin/escalas/Save'
import EscalasPendetes from '@/views/admin/escalas/Pendentes'
import EscalasPublicar from '@/views/admin/escalas/Publicar'
import EscalasRemoverPublicacao from '@/views/admin/escalas/RemoverPublicacao'
import RelatorioPerfilUnidade from '@/views/admin/escalas/RelatorioPerfilUnidade'
import GestaoPerfilUnidade from '@/views/admin/escalas/gestao/GestaoPerfilUnidade'
import EscalasRelatorio from '@/views/admin/escalas/Relatorio'
import EscalasVincularUnidadesUsuario from '@/views/admin/escalas/VincularUnidadesUsuario'
import EscalasImpressao from '@/views/admin/escalas/Impressao'

export const escalas = [
  {
    path: 'escalas/list',
    component: Escalas,
    meta: {
      requiresAuth: true,
      userAuth: true
    }
  },
  {
    path: 'escalas/add',
    name: 'escalas_add',
    component: EscalaSave,
    meta: {
      requiresAuth: true,
      userAuth: true
    }
  },
  {
    path: 'escalas/pendentes',
    component: EscalasPendetes,
    meta: {
      requiresAuth: true,
      userAuth: true
    }
  },
  {
    name: 'escalas_publicar',
    path: 'escalas/publicar',
    component: EscalasPublicar,
    meta: {
      requiresAuth: true,
      userAuth: true
    }
  },
  {
    name: 'escalas_remover_publicacao',
    path: 'escalas/remover-publicacao',
    component: EscalasRemoverPublicacao,
    meta: {
      requiresAuth: true,
      userAuth: true
    }
  },
  {
    name: 'relatorio_perfil_unidade',
    path: 'escalas/relatorio-perfil-unidade',
    component: RelatorioPerfilUnidade,
    meta: {
      requiresAuth: true,
      userAuth: true
    }
  },
  {
    name: 'gestao_perfil_unidade',
    path: 'escalas/gestao-perfil-unidade',
    component: GestaoPerfilUnidade,
    meta: {
      requiresAuth: true,
      userAuth: true
    }
  },
  {
    name: 'escalas_relatorio_status',
    path: 'escalas/relatorio',
    component: EscalasRelatorio,
    meta: {
      requiresAuth: true,
      userAuth: true
    }
  },
  {
    name: 'vincular-unidades-usuario',
    path: 'escalas/vincular-unidades-usuario',
    component: EscalasVincularUnidadesUsuario,
    meta: {
      requiresAuth: true,
      userAuth: true
    }
  },
  {
    name: 'escala-impressao',
    path: 'escalas/impressao',
    component: EscalasImpressao,
    meta: {
      requiresAuth: true,
      userAuth: true
    }
  }
]



// WEBPACK FOOTER //
// ./src/router/admin/escalas.js